// The reader-facing name of a work's license, keyed on the slug the api
// stores. Null for a slug with no name here: the page then says nothing rather
// than print a raw slug.
const LICENSE_LABELS = new Map(
  Object.entries({
    "cc-by": "CC BY 4.0 - Creative Commons Attribution",
    "cc-by-nc": "CC BY-NC 4.0 - Creative Commons Attribution-NonCommercial",
    "cc-by-nc-nd":
      "CC BY-NC-ND 4.0 - Creative Commons Attribution-NonCommercial-NoDerivatives",
    "cc-by-nc-sa":
      "CC BY-NC-SA 4.0 - Creative Commons Attribution-NonCommercial-ShareAlike",
    "cc-by-sa": "CC BY-SA 4.0 - Creative Commons Attribution-ShareAlike",
    "cc-by-nd": "CC BY-ND 4.0 - Creative Commons Attribution-NoDerivatives",
    "elsevier-tdm": "Elsevier User License",
    "other-oa": "Open Access",
    "public-domain": "Public Domain",
    "pmc-oa-subset": "PMC Open Access Subset",
  } as const satisfies Record<string, string>)
);

export function licenseLabel(license: string): string | null {
  const label = LICENSE_LABELS.get(license);
  return label === undefined ? null : label;
}
